export const isRecord = (value: unknown): value is Record<string, unknown> =>
  Boolean(value) && typeof value === "object" && !Array.isArray(value);

const collectRecords = (value: unknown): Record<string, unknown>[] => {
  if (!isRecord(value)) return [];
  const records = [value];
  if (isRecord(value.data)) records.push(value.data);
  if (isRecord(value.job)) records.push(value.job);
  return records;
};

export const parseNumericId = (value: unknown, keys: string[]): null | number => {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  for (const row of collectRecords(value)) {
    for (const key of keys) {
      const parsed = Number(row[key]);
      if (Number.isFinite(parsed) && row[key] !== "" && row[key] != null) return parsed;
    }
  }
  return null;
};

export const parseStringId = (value: unknown, keys: string[]): null | string => {
  if (typeof value === "string" && value.trim()) return value.trim();
  for (const row of collectRecords(value)) {
    for (const key of keys) {
      const field = row[key];
      if (typeof field === "string" && field.trim()) return field.trim();
      if (typeof field === "number" && Number.isFinite(field)) return String(field);
    }
  }
  return null;
};
